export function sizedImage(url: string, w: number): string {
  if (!url) return url;
  try {
    const u = new URL(url);
    u.searchParams.set("w", String(w));
    u.searchParams.set("auto", "format");
    u.searchParams.set("fm", "webp");
    u.searchParams.set("q", "70");
    return u.toString();
  } catch {
    return url;
  }
}
